<script lang="ts">
    import {dyData} from 'general/store';
    import Sale50 from 'desktop/icons/Sale50.svelte';
    import Sale25 from 'desktop/icons/Sale25.svelte';

    export let side = 'main';

    const icons = {
        Sale50,
        Sale25,
    };

    const saleText = $dyData.saleText?.[side];
</script>

<style>
    .saleText {
        position: absolute;
        display: flex;
        text-align: left;
        align-items: center;
        justify-content: center;
        gap: 20px;
        z-index: 1;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
    }
</style>

{#if saleText}
    <p
        class="saleText"
        class:iconItem={Boolean(saleText.icon)}
        style="
    top: {saleText.marginTop || 'auto'};
    bottom: {saleText.marginBottom || 'auto'};
    font-size: {saleText.fontSize || '20px'};
    font-weight: {saleText.fontWeight || '400'};
    line-height: {saleText.lineHeight || '1.25'};
    letter-spacing: {saleText.letterSpacing || '0'};
    text-decoration: {saleText.textDecoration || 'none'};
    color: {saleText.color || 'inherit'};
  "
    >
        {#if saleText.icon}<svelte:component this={icons[saleText.icon]} />{/if}
        {#if saleText.html} {@html saleText.html} {:else} {saleText.text}{/if}
    </p>
{/if}
